import axios from 'axios'
import {
  getAccessToken,
  clearTokens
} from './auth'

// TODO: get this from env
const BASE_URL =  process.env.API_BASE_URL //'http://localhost:3333'

//alert(process.env.API_BASE_URL)
function getPublicStartupBattles() {
  const url = `${BASE_URL}/api/battles/public`
  return axios.get(url).then(response => response.data)
}

axios.interceptors.response.use(response => {
   return response;
}, error => {

  // TODO: this is not very sustainable as there will be more routes
  if (error.response.status === 401 && window.location.href.includes("home") ) {

   // clear tokens just incase client logic thought user was logged in.
   clearTokens()
   window.location = "/"
  }

  return error;
})

function getNextStep() {
  const url = `${BASE_URL}/api/current`
  return axios.get(
    url,
    {headers: { Authorization: `Bearer ${getAccessToken()}` }}
  ).then(response => response.data).catch(err => {
    console.log(err)
  })
}

function getCompletions() {
  const url = `${BASE_URL}/api/completions`
  return axios.get(
    url,
    {headers: { Authorization: `Bearer ${getAccessToken()}` }}
  ).then(response => response.data)
}

function completeStep(step) {
  const url = `${BASE_URL}/api/complete`
  return axios.post(
    url,
    step,
    {headers: { Authorization: `Bearer ${getAccessToken()}` }}
  )
    .then(response => response.data)
}

function previousStep(step) {
  const url = `${BASE_URL}/api/previous`
  return axios.post(
    url,
    step,
    {headers: { Authorization: `Bearer ${getAccessToken()}` }}
  )
    .then(response => response.data)
}

function setChain(decision) {
  const url = `${BASE_URL}/api/changeChain`
  return axios.post(
    url,
    decision,
    {headers: { Authorization: `Bearer ${getAccessToken()}` }}
  )
    .then(response => response.data)
}

function getPrivateStartupBattles() {
  const url = `${BASE_URL}/api/battles/private`
  return axios.get(
    url, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    }
  ).then(response => response.data)
}


function setPreference(decision) {
  const url = `${BASE_URL}/api/setPreference`
  return axios.post(
    url,
    decision,
    {headers: { Authorization: `Bearer ${getAccessToken()}` }}
    ).then(response => response.data)
}

function makePayment (token) {
  const url = `${BASE_URL}/api/payment`
  return axios.post(
    url,
    {token: token},
    {headers: { Authorization: `Bearer ${getAccessToken()}` }}
  )
  .then(response => response.data)
}

function getUser () {
  const url = `${BASE_URL}/api/user`
  return axios.get(
    url,
    {headers: { Authorization: `Bearer ${getAccessToken()}` }}
  ).then(response => response.data)
}

function getPracticeSessions () {
  const url = `${BASE_URL}/api/practiceSessions`
  return axios.get(
    url,
    {headers: { Authorization: `Bearer ${getAccessToken()}` }}
  ).then(response => response.data)
}

function savePracticeSession (minutes, notes) {
  const url = `${BASE_URL}/api/practiceSessions`
  return axios.post(
    url,
    {
      minutes: minutes,
      notes: notes,
    },
    {headers: { Authorization: `Bearer ${getAccessToken()}` }}
  )
  .then(response => response.data)
}

export {
  getPublicStartupBattles,
  getPrivateStartupBattles,
  getNextStep,
  completeStep,
  previousStep,
  setChain,
  setPreference,
  makePayment,
  getUser,
  savePracticeSession,
  getPracticeSessions,
  getCompletions
}



// WEBPACK FOOTER //
// ./src/utils/battles-api.js